module.exports = __webpack_public_path__ + "img/icon-ok.c3465df2.svg";